import { render, staticRenderFns } from "./FichaCumpleanos.vue?vue&type=template&id=78431364"
import script from "./FichaCumpleanos.vue?vue&type=script&lang=js"
export * from "./FichaCumpleanos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports